import React, { useState, useEffect } from 'react'
import { trackPromise } from 'react-promise-tracker'

import { StyleSeries } from 'highcharts/HighchartsStyleHelper'
import {
    SetupDefaultOptions,
    FULL_HEIGHT_ONE_INPUT_ROW,
    DisableAllButFirstSeries,
} from 'highcharts/HighchartsHelper'

import { GetCurrentCoverage } from 'store/ChartApiClient'
import BreakdownStateRow from '../Components/BreakdownStateRow'
import LoadingWrapper from 'components/LoadingWrapper'
import HighchartsWrapper from '../../../../../../highcharts/HighchartsWrapper'
import { DarkBackgroundColor } from '../../../../../../highcharts/HighchartsStyleHelper'

const CurrentCoverageAnalysisStep = ({ id }) => {
    const PromiseArea = 'graph-current-coverage'

    const [breakdownStateValue, setBreakdownStateValue] = useState('Gross')
    const [coverageStateValue, setCoverageStateValue] = useState('None')
    const [durationStateValue, setDurationStateValue] = useState('Annual')

    const [options, setOptions] = useState({})
    const [error, setError] = useState(null)

    const [isLoaded, setIsLoaded] = useState(false)

    useEffect(() => {
        const StyleGraph = (opts) => {
            opts = SetupDefaultOptions(opts, FULL_HEIGHT_ONE_INPUT_ROW, false)

            if (opts.series) {
                opts.series = opts.series.map((p) => StyleSeries(p))
            }

            opts = {
                ...opts,
                plotOptions: {
                    ...opts.plotOptions,
                    column: {
                        ...opts.plotOptions.column,
                        stacking: 'normal',
                        dataLabels: {
                            ...opts.plotOptions.column.dataLabels,
                            enabled: true,
                        },
                    },
                    series: {
                        events: {
                            legendItemClick: (e) => {
                                const {
                                    target: {
                                        name,
                                        chart,
                                        chart: { options },
                                        visible,
                                    },
                                } = e
                                //fixes issue we resetting selection after init
                                setOptions(options)
                                // chart.reflow()
                            },
                        },
                    },
                },
            }

            if (opts.series) {
                // set color
                if (opts.series && opts.series[0]) {
                    opts.series[0].dataLabels = {
                        color: DarkBackgroundColor,
                    }
                }

                if (opts.series && opts.series[1]) {
                    opts.series[1].borderColor = '#FFFF00'
                    opts.series[1].dataLabels = {
                        color: 'red',
                    }
                }
            }

            if (!isLoaded) {
                opts.series = DisableAllButFirstSeries(opts.series)
            }

            setOptions(opts)
            setIsLoaded(true)
        }

        trackPromise(
            GetCurrentCoverage(id, breakdownStateValue, durationStateValue)
                .then((resp) => {
                    const { data } = resp
                    StyleGraph(data)
                })
                .catch((err) => {
                    setError(err)
                })
                .finally(() => {}),
            PromiseArea
        )
    }, [breakdownStateValue, durationStateValue, id])

    if (error) {
        return <p>Something went wrong, try again later</p>
    }

    return (
        <LoadingWrapper area={PromiseArea}>
            <HighchartsWrapper options={options} printHeightPx={450} />
            <BreakdownStateRow
                includeAccumulative={true}
                hideCoverage={true}
                breakdownValue={breakdownStateValue}
                coverageValue={coverageStateValue}
                durationValue={durationStateValue}
                breakdownChange={setBreakdownStateValue}
                coverageChange={setCoverageStateValue}
                durationChange={setDurationStateValue}
            />
        </LoadingWrapper>
    )
}

export default CurrentCoverageAnalysisStep
